import { IPostInventarioBody } from './../../interfaces/inventario/IPostInventarioBody';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IApiResponse, IListaPaginada } from 'src/app/interfaces';
import {
  IDownloadCSVInventario,
  IDownloadPDFInventario,
  IGetInventarioQueryParams,
  IInventario,
  IPostInventarioResponseData
} from 'src/app/interfaces/inventario';

@Injectable({
  providedIn: 'root'
})
export class InventarioService {
  private readonly baseURL = '/Inventario';
  constructor(private httpClient: HttpClient) {}

  getInventario(body: IGetInventarioQueryParams) {
    return this.httpClient.post<IApiResponse<IListaPaginada<IInventario>>>(
      `${this.baseURL}/ObterInventario`,
      body
    );
  }
  getDownloadPDFInventario(body: IDownloadPDFInventario) {
    return this.httpClient.post<IApiResponse<string>>(
      `${this.baseURL}/exportarPDF`,
      body
    );
  }
  getDownloadCSVInventario(body: IDownloadCSVInventario) {
    return this.httpClient.post<IApiResponse<string>>(
      `${this.baseURL}/exportarCSV`,
      body
    );
  }
  postInventario(body: IPostInventarioBody) {
    return this.httpClient.post<IApiResponse<IPostInventarioResponseData>>(
      this.baseURL,
      body
    );
  }
}
